import React from 'react';
import { connect } from 'react-redux';

import { updateFirm } from '../store/slices/firmsSlice';

import { createStdRequest, apiFetch, validatePhoneNumber, showAlert } from '../utils/utils';

import DA from '../store/ReduxAccess';

import ClickAwayTextField from './ClickAwayTextField';
import AlertModal from './AlertModal';
import CrmSnackbar from '../components/CrmSnackbar';

class OrgPropertyEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: '',
      snackbar: {
        isOpen: false,
        message: '',
      },
    };
  }

  componentDidMount() {
    this.setState({ content: this.props.value });
  }

  modifyApiStructForUpdating(firmStruct, propertyToken) {
    if (propertyToken === 'name') {
      return { ...firmStruct, name: this.state.content };
    } else if (propertyToken === 'officePhone') {
      this.savePhoneAsTempObject();
      return this.buildApiStructForUpdatingReferrerOrgIncludingFacilities();
    } else {
      return firmStruct;
    }
  }

  savePhoneAsTempObject() {
    const proposedNumber = this.state.content;
    if (proposedNumber.length === 0) {
      this.newPhoneObject = {};
    } else {
      // We have a valid phone number and must either modify the previous one or add this new one
      this.newPhoneObject = {
        roles: 'Business',
        countryCode: '1',
        number: proposedNumber,
      };
    }
  }

  buildApiStructForUpdatingReferrerOrgIncludingFacilities() {
    /*
        public int FirmId { get; set; }
        public string Name { get; set; }
        public string FirmType { get; set; }
        public string Description { get; set; }
        public string HomePageUrl { get; set; }
        public string FacebookUrl { get; set; }
        public List<FirmContactApiStruct> Contacts { get; set; } = new List<FirmContactApiStruct>();
        public List<FacilityApiStruct> Facilities { get; set; } = new List<FacilityApiStruct>();
  */
    const visibleFirmId = this.props.visibleFirmId;
    const visibleFirm = DA.getFirmById(visibleFirmId);

    const phoneNumbers = this.createPhonesArray();
    this.newPhoneObject = null;

    const reduxFacilities = DA.getFacilitiesForFirm(visibleFirmId);
    let amendedFacilities = undefined;
    if (reduxFacilities.length > 0) {
      const facilitiesHead = reduxFacilities[0];
      const facilitiesTail = reduxFacilities.slice(1);
      // copy phone number ID to modify DB entries, rather than creating new ones
      const oldPhoneNumbers = facilitiesHead.phoneNumbers;
      if (oldPhoneNumbers && oldPhoneNumbers.length > 0) {
        if (phoneNumbers && phoneNumbers.length > 0) {
          const phoneId = oldPhoneNumbers[0].phoneId;
          phoneNumbers[0].phoneId = phoneId;
        }
      }
      const newFacilitiesHead = { ...facilitiesHead, phoneNumbers };
      amendedFacilities = [newFacilitiesHead].concat(facilitiesTail);
    } else {
      amendedFacilities = [
        {
          facilityId: 0,
          name: 'Sole Facility',
          visibleFirmId,
          phoneNumbers: phoneNumbers,
        },
      ];
    }
    return {
      ...visibleFirm,
      facilities: amendedFacilities,
    };
  }

  createPhonesArray() {
    if (this.newPhoneObject && this.newPhoneObject.hasOwnProperty('number')) {
      return [this.newPhoneObject];
    } else {
      return [];
    }
  }

  handleClickOutside(newValue) {
    const changed = newValue !== this.state.content;
    console.log(`comparing old: ${this.state.content} with new: ${newValue} => changed: ${changed}`);
    if (changed) {
      this.setState({ content: newValue }, () => this.saveToDb());
    }
  }

  saveToDb() {
    const propertyToken = this.props.propertyToken;
    if (propertyToken === 'description') {
      this.saveDescriptionToDb();
    } else {
      this.saveRandomToDb(propertyToken);
    }
  }

  saveDescriptionToDb() {
    // build API struct
    const viewingFirmId = DA.getFirmId();
    const { visibleFirmId } = this.props;
    const f2fvApiStruct = this.buildApiStructForUpdatingDescription(visibleFirmId);
    const uri = `/api/firm/${viewingFirmId}/visibleFirm`;
    const request = createStdRequest(uri, 'post', f2fvApiStruct);
    const actionOnGoodResponse = (json) => {
      const reduxRep = DA.getFirmById(visibleFirmId);
      const copiedRep = { ...reduxRep, description: this.state.content };
      this.props.updateFirm(copiedRep);
      this.setState({
        snackbar: {
          message: 'Description saved',
          isOpen: true,
        },
      });
    };
    // call API
    apiFetch(this, request, actionOnGoodResponse);
  }

  buildApiStructForUpdatingDescription(visibleFirmId) {
    const reduxRep = DA.getFirmById(visibleFirmId);
    const { firmType, temperature } = reduxRep;
    return {
      viewingFirmId: DA.getFirmId(),
      visibleFirmId,
      firmType,
      description: this.state.content,
      temperature,
    };
  }

  saveRandomToDb(propertyToken) {
    if (propertyToken === 'officePhone' && this.state.content) {
      const validation = validatePhoneNumber(this.state.content);
      if (!validation.valid) {
        showAlert(this, validation.errorMessage);
        return;
      }
    }
    // build API struct
    const { visibleFirmId } = this.props;
    const firm = DA.getFirmById(visibleFirmId);
    const modified = this.modifyApiStructForUpdating(firm, propertyToken);
    const uri = '/api/firm';
    const request = createStdRequest(uri, 'post', modified);
    const actionOnGoodResponse = (json) => {
      this.props.updateFirm(modified);
    };
    // call API
    apiFetch(this, request, actionOnGoodResponse);
  }

  render() {
    const { label, required, multiline } = this.props;
    return (
      <div>
        <AlertModal show={this.state.shouldShowAlertModal} renderer={this} text={this.state.alertModalText} />
        <CrmSnackbar renderer={this} options={this.state.snackbar} />

        <ClickAwayTextField
          label={label}
          initialText={this.state.content}
          required={required}
          multiline={multiline}
          isPhoneField={this.props.propertyToken === 'officePhone'}
          outsideClickHandler={(newValue) => this.handleClickOutside(newValue)}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const actionProducers = { updateFirm };

export default connect(mapStateToProps, actionProducers)(OrgPropertyEditor);
